const NewOverallEN = {
  NewOverall: {
    NEXT: 'Next',
    ADD_BUDGET: 'Add budget',
    SINGLE_SELECTED_GROUP: ' group selected',
    SOME_SELECTED_GROUP: ' groups selected',
    BUDGET_GOAL: 'Change period goal',
    BUDGET_ALLOCATED: 'See history',
    BUDGET_NOT_ALLOCATED: 'Change budget in large scale',
    GOAL_PERIOD: 'Goal period',
    ALLOCATED: 'Allocated',
    NOT_ALLOCATED: 'Not allocated',
    ACCS_AND_GROUPS: 'Accounts and groups',
    SPENT: 'Spent',
    BUDGET: 'Budget',
    ACCOUNT: 'Account',
    TOTAL: 'Total',
    SPEND: 'Spend',
    REMANING: 'Remaning budget',
    CHANGE_BUDGET_MODAL_TITLE: 'Mass Budget',
    CHANGE_BUDGET_MODAL_DESCRIPTION: 'Add budget to all divisional stores',
    CHANGE_BUDGET_MODAL_PLACEHOLDER: 'Value to add',
    CHANGE_GOAL_MODAL_TITLE: 'Edit period goal',
    CHANGE_GOAL_MODAL_PLACEHOLDER: 'New period goal',
    SUCCESS_MESSAGE_CHANGE_BUDGET: 'Budget changed successfully!',
    ERROR_MESSAGE_NOT_ENOUGH_BUDGET: "You don't have enough budget, please send another value.",
    ERROR_MESSAGE_WAIT:
    'A mass distribution is already in progress. Wait for it to finish before starting a new one.',
    ERROR_MESSAGE_INVALID: 'Bulk distribution is only supported in Groups.',
    ERROR_MESSAGE_CHANGE_BUDGET: 'Error on changing budget, try again later!',
    SUCCESS_MESSAGE_EDIT_GOAL:
    'Period goal was changed successfully, please wait a moment for the values to be updated!',
    ERROR_MESSAGE_EDIT_GOAL: 'Error on change monthly goal, try again later!',
    BUTTON_CONFIRM: 'Confirm',
    OPEN: 'Open',
    IMPRESSIONS: 'Impressions',
    VIDEO_VIEWS: 'Video Views',
    ENGAGEMENT: 'Engagement',
    RATE_ENGAGEMENT: 'Engagement Rate',
    PAGES: 'Pages',
    STRATEGIES: 'Strategies',
    ACCOUNTS: 'Accounts',
    GROUPS: 'Groups',
    DEPOSIT: 'Deposit',
    REMOVE: 'Remove',
    TITLE_DEPOSIT: 'Add budget',
    TITLE_REMOVE: 'Remove budget',
    SUBTITLE_DEPOSIT: 'Increase the budget amount',
    SUBTITLE_REMOVE: 'Decreate the budget amount',
    MAXIMUM: 'Maximum',
    NEW_BUDGET: 'New budget',
    GROUP: 'Group',
    BUTTON_CANCEL: 'Cancel',
    SUCCESS_DEPOSIT: 'Deposit was successful',
    ERROR_DEPOSIT: 'Deposit failed',
    SUCCESS_WITHDRAW: 'Withdrawal was successful',
    ERROR_WITHDRAW: 'Withdrawal failed',
    INSUFFICIENT_BUDGET: 'Not enough budget',
    TYPE_HERE: 'Type the value here',
    CLEAR_FILTER: 'Clear Filter',
    REMOVE_BUDGET_OPTION: 'Remove budget',
    DISTRIBUTED_BUDGET: 'Distributed budget',
    SPENDED_BUDGET: 'Spent money',
    DEPOSIT_SUCCESS_MESSAGE: 'Deposit done successfully.',
    DEPOSIT_FAILURE_MESSAGE: 'There was an error trying to make the deposit.',
    DEPOSIT_VERIFICATION_FAILURE: 'The deposit amount must be greater than zero.',
    DEPOSIT_VERIFICATION_SELECT_UNIT: 'Select at least one unit.',
    DEPOSIT_FAILURE_VALIDATE_SELECTED_UNITS: 'An error occurred while trying to validate the selected units.',
    DEPOSIT_SUBTITLE_PAGE3: 'Check below the amount and place where the amount will be deposited.',
    DEPOSIT_SUBTITLE_PAGE1: 'Enter the unit amount you wish to deposit.',
    INTELLIGENT_AMOUT_DISTRIBUTION_ACTIVATED: 'Smart redistribution of money activated.',
    INTELLIGENT_AMOUT_DISTRIBUTION_INACTIVATED: 'Smart redistribution of money inactivated.',
    REDISTRIBUTION_INTELLIGENT_SYSTEM: 'Intelligent budget redistribution system.',
    KNOW_MORE: 'Know more',
    INTELLIGENT_REDISTRIBUTION: 'Intelligent redistribution!',
    ACTIVATE: 'Activate',
    IN_USE: 'In use',
    AVAILABLE: 'Available',
    AMOUNT_INVESTED: 'Amount invested',
    AMOUNT_IN_USE: 'Amount in use',
    INVALID_GROUPS_MESSAGE_FAILURE: 'Selected groups are not able to make a deposit.',
    DISABLED_AD_ACCOUNT: 'Disabled ad account',

    LOADING: '...',

    // Edit goal
    MODAL_EDIT_GOAL_TITLE: 'Change goal period',
    MODAL_EDIT_GOAL_INPUT_LABEL: 'value',
    CARD_MODAL_EDIT_GOAL_TITLE: 'Edit',
    // Edit goal

    // Budget Cards Tooltips
    GOAL_PERIOD_TOOLTIP: 'Value set to be distributed across groups and units.',
    SPENT_BUDGET_TOOLTIP: 'Amount spent until now.',
    IN_USE_TOOLTIP: 'Amount already allocated to ads that are active or scheduled.',
    AVAILABLE_TOOPIP: 'Available value of period goal to be distributed among groups and units.',
    // Budget Cards Tooltips

    SPENDED_BUDGET2: 'money spent:',
  },
};

const NewOverallPT = {
  NewOverall: {
    NEXT: 'Avançar',
    ADD_BUDGET: 'Depositar verba',
    SINGLE_SELECTED_GROUP: ' grupo selecionado',
    SOME_SELECTED_GROUP: ' grupos selecionados',
    GROUP: 'Grupo',
    BUDGET_GOAL: 'Alterar meta do período',
    BUDGET_ALLOCATED: 'Ver histórico',
    BUDGET_NOT_ALLOCATED: 'Alterar orçamento em massa',
    GOAL_PERIOD: 'Meta do período',
    ALLOCATED: 'Verba alocada',
    NOT_ALLOCATED: 'Verba disponível',
    ACCS_AND_GROUPS: 'Grupos e contas',
    SPENT: 'Gastos',
    BUDGET: 'Verba',
    ACCOUNT: 'Conta',
    TOTAL: 'Total',
    SPEND: 'Gasto',
    REMANING: 'Verba restante',
    CHANGE_BUDGET_MODAL_TITLE: 'Orçamento em massa',
    CHANGE_BUDGET_MODAL_DESCRIPTION: 'Adicionar orçamento em todas as lojas do grupo',
    CHANGE_BUDGET_MODAL_PLACEHOLDER: 'Valor a adicionar',
    CHANGE_GOAL_MODAL_TITLE: 'Editar meta do período',
    CHANGE_GOAL_MODAL_PLACEHOLDER: 'Nova meta do período',
    SUCCESS_MESSAGE_CHANGE_BUDGET: 'Orçamento alterado com sucesso!',
    ERROR_MESSAGE_NOT_ENOUGH_BUDGET: 'Você não tem orçamento suficiente, por favor envie outro valor.',
    ERROR_MESSAGE_WAIT:
    'Uma distribuição em massa já está em andamento. Aguarde a finalização para iniciar uma nova.',
    ERROR_MESSAGE_INVALID: 'Distribuição em massa só é suportada em grupos',
    ERROR_MESSAGE_CHANGE_BUDGET: 'Erro ao alterar orçamento, tente novamente mais tarde!',
    SUCCESS_MESSAGE_EDIT_GOAL:
    'Meta do período foi alterada com sucesso, aguarde alguns instantes para que os valores sejam atualizados!',
    ERROR_MESSAGE_EDIT_GOAL: 'Erro ao alterar a meta mensal, tente novamente mais tarde!',
    BUTTON_CONFIRM: 'Confirmar',
    OPEN: 'Abrir',
    IMPRESSIONS: 'Impressões',
    VIDEO_VIEWS: 'Visualizações',
    ENGAGEMENT: 'Engajamentos',
    RATE_ENGAGEMENT: 'Taxa de engajamento',
    PAGES: 'Páginas',
    STRATEGIES: 'Estratégias',
    ACCOUNTS: 'Contas',
    GROUPS: 'Grupos',
    DEPOSIT: 'Depositar',
    REMOVE: 'Remover',
    TITLE_DEPOSIT: 'Depositar verba',
    TITLE_REMOVE: 'Retirar verba',
    SUBTITLE_DEPOSIT: 'Aumente o valor do orçamento',
    SUBTITLE_REMOVE: 'Diminua o valor do orçamento',
    MAXIMUM: 'Máximo',
    NEW_BUDGET: 'Novo orçamento',
    BUTTON_CANCEL: 'Cancelar',
    SUCCESS_DEPOSIT: 'Sucesso ao realizar o depósito!',
    ERROR_DEPOSIT: 'Falha ao realizar o depósito, tente novamente mais tarde!',
    SUCCESS_WITHDRAW: 'Sucesso ao remover o orçamento!',
    ERROR_WITHDRAW: 'Falha ao remover o orçamento, tente novamente mais tarde!',
    INSUFFICIENT_BUDGET: 'Saldo insuficiente.',
    TYPE_HERE: 'Digite o valor aqui',
    CLEAR_FILTER: 'Limpar Seleção',
    REMOVE_BUDGET_OPTION: 'Remover verba',
    DISTRIBUTED_BUDGET: 'Verba distribuida',
    SPENDED_BUDGET: 'Verba gasta',
    DEPOSIT_SUCCESS_MESSAGE: 'Verba adicionada com sucesso.',
    DEPOSIT_FAILURE_MESSAGE: 'Ocorreu um erro ao tentar adicionar a verba.',
    DEPOSIT_VERIFICATION_FAILURE: 'O valor da verba precisa ser maior de zero.',
    DEPOSIT_VERIFICATION_SELECT_UNIT: 'Selecione pelo menos uma unidade.',
    DEPOSIT_FAILURE_VALIDATE_SELECTED_UNITS: 'Ocorreu um erro ao tentar validar as unidades selecionadas.',
    DEPOSIT_SUBTITLE_PAGE3: 'Confira abaixo o valor e local onde será depositada a verda.',
    DEPOSIT_SUBTITLE_PAGE1: 'Digite o valor unitário que deseja depositar.',
    INTELLIGENT_AMOUT_DISTRIBUTION_ACTIVATED: 'Redistribuição de verba inteligente ativada.',
    INTELLIGENT_AMOUT_DISTRIBUTION_INACTIVATED: 'Redistribuição de verba inteligente desativada.',
    REDISTRIBUTION_INTELLIGENT_SYSTEM: 'Sistema de redistribuição de verba inteligente.',
    KNOW_MORE: 'Saiba mais',
    INTELLIGENT_REDISTRIBUTION: 'Redistribuição inteligente!',
    ACTIVATE: 'Ativar',
    IN_USE: 'Verba projetada',
    AVAILABLE: 'Disponível',
    AMOUNT_INVESTED: 'verba investida',
    AMOUNT_IN_USE: 'verba em uso',
    INVALID_GROUPS_MESSAGE_FAILURE: 'Os grupos selecionados não estão aptos para realizar um depósito.',
    DISABLED_AD_ACCOUNT: 'Conta de anúncios desativada',

    LOADING: '...',

    // Edit goal
    MODAL_EDIT_GOAL_TITLE: 'Alterar valor da meta',
    MODAL_EDIT_GOAL_INPUT_LABEL: 'valor da meta',
    CARD_MODAL_EDIT_GOAL_TITLE: 'Editar',
    // Edit goal

    // Budget Cards Tooltips
    GOAL_PERIOD_TOOLTIP: 'Valor definido para ser distribuído entre grupos e unidades.',
    SPENT_BUDGET_TOOLTIP: 'Valor gasto até o momento.',
    IN_USE_TOOLTIP: 'Valor já alocado em anúncios que estão ativos ou agendados.',
    AVAILABLE_TOOPIP: 'Valor disponível da meta do período para ser distribuído entre grupos e unidades.',
    // Budget Cards Tooltips

    SPENDED_BUDGET2: 'verba gasta:',
  },
};

const NewOverallES = {
  NewOverall: {
    NEXT: 'Avance',
    ADD_BUDGET: 'Depositar dinero',
    SINGLE_SELECTED_GROUP: ' grupo seleccionado',
    SOME_SELECTED_GROUP: ' grupos seleccionados',
    GROUP: 'Grupo',
    BUDGET_GOAL: 'Cambiar el objetivo del período',
    BUDGET_ALLOCATED: 'Ver historial',
    BUDGET_NOT_ALLOCATED: 'Cambiar el presupuesto masivo',
    GOAL_PERIOD: 'Meta del período',
    ALLOCATED: 'Presupuesto asignado',
    NOT_ALLOCATED: 'Fondos disponibles',
    ACCS_AND_GROUPS: 'Grupos y cuentas',
    SPENT: 'Gasto',
    BUDGET: 'Presupuesto',
    ACCOUNT: 'Cuenta',
    TOTAL: 'Total',
    SPEND: 'Gastado',
    REMANING: 'Dinero sobrante',
    CHANGE_BUDGET_MODAL_TITLE: 'Presupuesto masivo',
    CHANGE_BUDGET_MODAL_DESCRIPTION: 'Agregar presupuesto a todas las tiendas del grupo',
    CHANGE_BUDGET_MODAL_PLACEHOLDER: 'Valor para agregar',
    CHANGE_GOAL_MODAL_TITLE: 'Editar objetivo del período',
    CHANGE_GOAL_MODAL_PLACEHOLDER: 'Nuevo objetivo de período',
    SUCCESS_MESSAGE_CHANGE_BUDGET: 'El presupuesto se modificó correctamente!',
    ERROR_MESSAGE_NOT_ENOUGH_BUDGET: 'No tiene presupuesto suficiente, envíe otro valor.',
    ERROR_MESSAGE_WAIT:
    'Ya está en marcha una distribución masiva. Espere a que se complete para comenzar uno nuevo.',
    ERROR_MESSAGE_INVALID: 'La distribución masiva solo se admite en grupos.',
    ERROR_MESSAGE_CHANGE_BUDGET: 'Error al cambiar el presupuesto. Vuelve a intentarlo más tarde.',
    SUCCESS_MESSAGE_EDIT_GOAL:
    'El objetivo del período se ha cambiado correctamente. Espere unos momentos para que se actualicen los valores.',
    ERROR_MESSAGE_EDIT_GOAL: 'Error al cambiar el objetivo mensual. Vuelve a intentarlo más tarde.',
    BUTTON_CONFIRM: 'Confirmar',
    OPEN: 'Abierto',
    IMPRESSIONS: 'Impresiones',
    VIDEO_VIEWS: 'Vistas',
    ENGAGEMENT: 'Compromisos',
    RATE_ENGAGEMENT: 'Tasa de participación',
    PAGES: 'Paginas',
    STRATEGIES: 'Estrategias',
    ACCOUNTS: 'Cuentas',
    GROUPS: 'Grupos',
    DEPOSIT: 'Depositar',
    REMOVE: 'Eliminar',
    TITLE_DEPOSIT: 'Depositar dinero',
    TITLE_REMOVE: 'Retirar fondos',
    SUBTITLE_DEPOSIT: 'Aumentar el monto del presupuesto',
    SUBTITLE_REMOVE: 'Disminuir el monto del presupuesto',
    MAXIMUM: 'Máximo',
    NEW_BUDGET: 'Nuevo presupuesto',
    BUTTON_CANCEL: 'Cancelar',
    SUCCESS_DEPOSIT: 'Éxito al realizar el depósito',
    ERROR_DEPOSIT: 'Error al depositar. Vuelve a intentarlo más tarde!',
    SUCCESS_WITHDRAW: 'Eliminación exitosa del presupuesto!',
    ERROR_WITHDRAW: 'No se pudo quitar el presupuesto. Vuelve a intentarlo más tarde!',
    INSUFFICIENT_BUDGET: 'Fondos insuficientes.',
    TYPE_HERE: 'Ingrese el valor aquí',
    CLEAR_FILTER: 'Selección clara',
    REMOVE_BUDGET_OPTION: 'Eliminar fondos',
    DISTRIBUTED_BUDGET: 'Dinero asignado',
    SPENDED_BUDGET: 'Dinero gastado',
    DEPOSIT_SUCCESS_MESSAGE: 'Suma agregada con éxito.',
    DEPOSIT_FAILURE_MESSAGE: 'Se produjo un error al intentar agregar el presupuesto.',
    DEPOSIT_VERIFICATION_FAILURE: 'El monto de la subvención debe ser superior a cero.',
    DEPOSIT_VERIFICATION_SELECT_UNIT: 'Seleccione al menos una unidad.',
    DEPOSIT_FAILURE_VALIDATE_SELECTED_UNITS: 'Ocurrió un error al intentar validar las unidades seleccionadas.',
    DEPOSIT_SUBTITLE_PAGE3: 'Consulta a continuación el valor y el lugar donde se depositará la verdad.',
    DEPOSIT_SUBTITLE_PAGE1: 'Ingrese el monto de la unidad que desea depositar.',
    INTELLIGENT_AMOUT_DISTRIBUTION_ACTIVATED: 'Redistribución inteligente del presupuesto habilitada.',
    INTELLIGENT_AMOUT_DISTRIBUTION_INACTIVATED: 'Redistribución inteligente del presupuesto inhabilitada.',
    REDISTRIBUTION_INTELLIGENT_SYSTEM: 'Sistema inteligente de redistribución de presupuestos.',
    KNOW_MORE: 'Sepa mas',
    INTELLIGENT_REDISTRIBUTION: 'Redistribución inteligente!',
    ACTIVATE: 'Activar',
    IN_USE: 'Presupuesto proyectado',
    AVAILABLE: 'Disponible',
    AMOUNT_INVESTED: 'dinero invertido',
    AMOUNT_IN_USE: 'presupuesto en uso',
    INVALID_GROUPS_MESSAGE_FAILURE: 'Los grupos seleccionados no pueden hacer un depósito.',
    DISABLED_AD_ACCOUNT: 'Cuenta de anuncios inhabilitada',

    LOADING: '...',

    // Edit goal
    MODAL_EDIT_GOAL_TITLE: 'Cambiar el valor del objetivo',
    MODAL_EDIT_GOAL_INPUT_LABEL: 'valor objetivo',
    CARD_MODAL_EDIT_GOAL_TITLE: 'Para editar',
    // Edit goal

    // Budget Cards Tooltips
    GOAL_PERIOD_TOOLTIP: 'Conjunto de valores para distribuir entre grupos y unidades.',
    SPENT_BUDGET_TOOLTIP: 'Cantidad gastada hasta ahora.',
    IN_USE_TOOLTIP: 'Cantidad ya asignada a anuncios que están activos o programados.',
    AVAILABLE_TOOPIP: 'Valor disponible del objetivo del período que se distribuirá entre grupos y unidades.',
    // Budget Cards Tooltips

    SPENDED_BUDGET2: 'dinero gastado:',
  },
};

export { NewOverallEN, NewOverallPT, NewOverallES };
